<!--
    描述：清标页面
    时间：2021-09-23
    Created by 王帅
-->
<template>
    <w-split v-model="splitV" class="clear-section-main">
        <!-- 左侧结构树 -->
        <left-structure
            slot="left"
            :editable="false"
            :showCheckbox="true"
            ref="leftTree"
            @rowClick="leftRowClick"
            @onCheck="checkChange"
        ></left-structure>

        <!-- 右侧表格 -->
        <div class="w-strucutre-layout" slot="right">
            <div class="w-strucutre-header">
                <span class="title pdl10 text-overflow">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="curName"
                        placement="bottom-start"
                    >
                        <span>{{ curName }}</span>
                    </el-tooltip>
                </span>
                <div class="btnGroups">
                    <el-tooltip effect="light" popper-class="help-content" append-to-body>
                        <div slot="content">
                            <p>
                                1.先勾选左侧项目结构单位工程(左侧勾选哪一个单位工程，则对该单位工程量进行清单一致性检查)。
                            </p>
                            <p>
                                2.选择一个投标报价单位（无投标报价单位，则需先导入)，进行清单检查分析。
                            </p>
                            <p>
                                3.分析后可点击“导出Excel”导出。也可点击“手动分析”设置分析规则后，再导出分析报告。
                            </p>
                        </div>
                        <span class="help-title"
                            ><i class="el-icon-question"></i> 帮助说明</span
                        >
                    </el-tooltip>
                    <el-button
                        size="small"
                        icon="el-icon-menu"
                        type="primary"
                        @click="addFile"
                        >导入投标报价
                    </el-button>
                    <el-button
                        size="small"
                        icon="el-icon-menu"
                        :type="showAllData ? 'danger' : 'success'"
                        @click="changeTableType"
                        >{{ showAllData ? "异常清单" : "全部清单" }}
                    </el-button>
                    <el-button size="small" icon="el-icon-data-line" type="primary" @click="openRule"
                        >手动分析
                    </el-button>
                    <el-button size="small" icon="el-icon-menu" type="primary" @click="doFilter"
                    >列过滤
                    </el-button>
                    <el-button size="small"
                               icon="el-icon-refresh"
                               type="warning"
                               @click="doReset">重置
                    </el-button>
                    <el-button size="small" icon="el-icon-printer" @click="doExport('excel')"
                        >导出Excel
                    </el-button>
                    <el-button
                        size="small"
                        icon="el-icon-upload"
                        v-if="roleBtns.includes('detail-Html')"
                        @click="doExport('html')"
                        >导出Html
                    </el-button>
                </div>
            </div>

            <div class="w-structure-content" v-loading="sheetLoading">
                <detail-table ref="detailTable" @changeUnit="changeUnit"></detail-table>
            </div>

            <!-- 导入弹窗 -->
            <el-dialog
                :title="dialogObj.title"
                :visible.sync="dialogObj.visible"
                :width="dialogObj.width"
                :close-on-click-modal="false"
                @closed="handleClose"
            >
                <!-- 初始新增选择 文件类型等 -->
                <div
                    class="text-center h100 overflow-hidden"
                    v-if="dialogObj.addType === 'addFile'"
                >
                    <el-form
                        ref="addForm"
                        class="pdr5"
                        :model="addForm"
                        :rules="addRules"
                        label-width="160px"
                    >
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="投标单位名称" prop="name">
                                    <el-input
                                        v-model="addForm.name"
                                        placeholder="请输入"
                                        @blur="onCheckName"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="投标单位报价总额" prop="sumMoney">
                                    <el-input
                                        type="number"
                                        v-model.number="addForm.sumMoney"
                                    >
                                        <template slot="append">元</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="计价依据" prop="priceBasis">
                                    <el-select
                                        v-model="addForm.priceBasis"
                                        placeholder="请选择"
                                    >
                                        <el-option
                                            v-for="(item, index) in basisList"
                                            :key="'造价依据' + index"
                                            :label="item.sname"
                                            :value="item.value"
                                            :disabled="item.value !== '1006002'"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="文件类型" class="text-left">
                                    <el-radio v-model="addForm.fileType" label="0"
                                        >XML</el-radio
                                    >
                                    <el-radio
                                        v-model="addForm.fileType"
                                        disabled
                                        label="1"
                                        >Excel</el-radio
                                    >
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="24">
                                <el-form-item
                                    label="上传文件"
                                    :rules="[{ required: true }]"
                                >
                                    <my-upload
                                        :aid="aid"
                                        mode="add"
                                        ref="myUpload"
                                        :multiple="false"
                                        :maxNum="1"
                                        :acceptType="acceptType"
                                    ></my-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>

                <!-- 填写金额 与 文件金额不符合的说明 -->
                <div
                    class="text-center h100 overflow-hidden"
                    v-if="dialogObj.addType === 'difference'"
                >
                    <el-form
                        class="pdr5"
                        ref="softForm"
                        :model="addForm"
                        label-width="120px"
                    >
                        <el-form-item label="填报金额">
                            <el-input disabled v-model="addForm.sumMoney"></el-input>
                        </el-form-item>
                        <el-form-item label="文件读取金额">
                            <el-input disabled v-model="addForm.fileAmount"></el-input>
                        </el-form-item>
                        <el-form-item label="差款金额">
                            <el-input disabled :value="computePrice"></el-input>
                        </el-form-item>
                        <el-form-item label="差款幅度">
                            <el-input disabled :value="computeRange">
                                <template slot="append">
                                    <span>%</span>
                                </template>
                            </el-input>
                        </el-form-item>
                        <!-- <el-form-item
                            label="说明"
                            prop="softName"
                            :rules="{ required: true, trigger: 'blur' }"
                        >
                            <el-input
                                type="textarea"
                                v-model="addForm.softName"
                                :autosize="{ minRows: 2, maxRows: 4 }"
                                placeholder="请输入内容, 最多不可超过360个字"
                                maxlength="360"
                                show-word-limit
                            ></el-input>
                        </el-form-item> -->
                    </el-form>
                </div>

                <!-- xml 的文件处理 -->
                <div
                    class="text-center h100 overflow-hidden"
                    v-if="dialogObj.addType === 'preview'"
                >
                    <xml-preview
                        :tableData="addForm.param1"
                        :fileName="addForm.param3"
                        ref="xmlPreview"
                        :unitList="DanWeiByProjectList"
                    ></xml-preview>
                </div>

                <!-- 底部按钮 -->
                <div
                    slot="footer"
                    v-if="dialogObj.type === 'add'"
                    class="dialog-footer text-center"
                >
                    <el-button @click="doCancel" size="small">取 消</el-button>
                    <el-button
                        type="primary"
                        size="small"
                        :loading="btnLoading"
                        @click="doConfirm"
                        >确 定</el-button
                    >
                </div>
            </el-dialog>

            <!-- 规则弹窗 -->
            <el-dialog
                :visible.sync="ruleDialog.visible"
                :title="ruleDialog.title"
                :width="ruleDialog.width"
                :close-on-click-modal="false"
                top="100px"
                @closed="handleRuleClose"
            >
                <!-- 第二步 打开具体规则 -->
                <template v-if="ruleDialog.step === 2">
                    <rule-table ref="ruleTable" :mode="ruleDialog.mode" :isSys="isSys" needSave></rule-table>
                </template>

                <!-- footer 组件 -->
                <div
                    slot="footer"
                    class="dialog-footer text-center"
                >
                    <el-button size="small" @click="ruleDialog.visible = false"
                        >取 消</el-button
                    >
                    <el-button
                        type="primary"
                        size="small"
                        :loading="ruleDialog.btnLoading"
                        @click="onRuleConfirm"
                        >确 定</el-button
                    >
                </div>
            </el-dialog>

            <!-- 上传进度 -->
            <el-dialog title="上传进度"
                       width="65%"
                       class="progressDialog"
                       :visible.sync="progressData.show"
                       :close-on-click-modal="false"
                       :close-on-press-escape="false"
                       :show-close="false"
                       :append-to-body="true">
                <div>
                    <el-row v-for="(i, index) in progressData.eventList"
                            :key="'eventList' + index">
                        <el-col :span="8">
                            <div class="inputTitle">
                                {{ i.name }}
                            </div>
                        </el-col>
                        <el-col :span="16">
                            <el-row class="progressBox"
                                    :gutter="20">
                                <el-col :span="10"
                                        class="progressCol">
                                    <el-progress :text-inside="true"
                                                 :stroke-width="26"
                                                 :percentage="i.progress"></el-progress>
                                </el-col>
                                <el-col :span="12"
                                        class="progressInfo">
                                    {{ i.progressInfo }}&nbsp;
                                    <i class="el-icon-loading"
                                       v-show="i.progressLoading"></i>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                </div>
            </el-dialog>
        </div>
    </w-split>
</template>

<script>
import { exportExcel, dateFormat } from '@/utils/tools'
// vue 组件
import leftStructure from "@/views/project-management/project-info/components/left_structure.vue";
import detailTable from "./clear_detail_table.vue";
import myUpload from "components/upload/upload";
import xmlPreview from "@/views/project-management/cost-files/xml-preview"; //XML
import ruleTable from "@/views/basic-template/rule-setting/rule_table.vue";

// js
import { mapState } from "vuex";
import { deleteFile } from '@/api/modules/upload'
import {getClearNameUnits} from '@/api/modules/analysisInventory'
import {
    parseXml,
    getSelectUnit,
    saveData,
    checkName,
    getRulesList,
    getUnitList
} from "@/api/modules/clearSection.js";

export default {
    name: "",
    components: {
        leftStructure,
        detailTable,
        myUpload,
        xmlPreview,
        ruleTable
    },
    data() {
        return {
            splitV: 0.1,
            curName: "", // 当前点击的 结构树层级名称
            curTreeIds: [], // 当前选择的 树ID
            // 加载查询的对象
            queryParams: {
                // id: '', // 规则ID
                rules: {},  // 规则对象
                unitProjectIdList: [],  // 当前选择的 树ID
                tendererId: ''  // 投标报价单位id
                // tendererId: '1442025483445923841'  // 投标报价单位id
            },
            tendererList: [],   // 投标单位列表
            // 表格相关
            showAllData: true, // 是否展示全部清单数据
            sheetLoading: false,
            // 导入弹窗
            dialogObj: {
                title: "导入投标报价",
                visible: false,
                width: "800px",
                type: "add",
                addType: "addFile",
            },
            btnLoading: false,
            // 导入弹窗表单
            addForm: {
                name: "", // 投标单位名称
                sumMoney: undefined, // 输入的金额
                priceBasis: "1006002", // 计价依据
                fileType: "0", // 文件类型
                fileAmount: 0, // 文件金额
                // softName: '',
                param1: [], // 结构名称
                param2: "", // 左侧项目结构树树id
                param3: "", // 造价文件名称
                param4: [], // 后台参数
            },
            addRules: {
                // 单位名称
                name: [
                    {
                        type: "string",
                        required: true,
                        message: "请输入投标单位名称",
                    },
                ],
                // 报价总额
                sumMoney: [
                    {
                        required: true,
                        message: "请输入投标单位报价总额",
                    },
                ],
                // 计价依据
                priceBasis: [
                    {
                        type: "string",
                        required: true,
                        message: "请选择计价依据",
                        trigger: "change",
                    },
                ],
            },
            aid: "", // 上传组件业务表ID
            fileList: [], // 上传的文件
            // 单位工程数组
            DanWeiByProjectList: [],
            // 规则弹窗相关
            ruleDialog: {
                title: "手动分析",
                visible: false,
                width: "1000px",
                mode: "edit",
                step: 0,
                btnLoading: false,
            },
            pageLoading: false,
            // 进度条
            saveFileId: [],
            progressData: {
                show: false,
                eventList: [],
            },
            progressOverWatch: null,
            isSys: '3'
        };
    },
    created() {
        // 初始获取单位工程数组
        this.getDanWeiList();
        // 获取默认规则
        this.getRules()

        // 删除附件
        if (this.saveFileId.length > 0) {
            this.deleteFile()
        }
    },
    methods: {
        // 左侧项目结构树点击事件
        leftRowClick(row) {
            // 项目名称 以及  当前层级名称
            let _pname = this.projectName;
            let _name = row.sname;

            // 第一级
            if (row.levelType === 0) {
                this.curName = _name;
            } else if (row.levelType === 1) {
                this.curName = _pname + " | " + _name;
            } else {
                let _dname = this.$refs.leftTree.tableData[0].children.find(
                    (x) => x.id === row.pid
                ).sname;
                this.curName = _pname + " | " + _dname + " | " + _name;
            }
        },

        // 左侧树复选框选择事件
        checkChange(arr) {
            // 保存查询数组
            this.queryParams.unitProjectIdList = arr;
            let queryParams = {};
            queryParams.treeIds = arr;
            queryParams.projectId = this.curProjectId;
            // 加载表格
            this.loadDetailTable()
            // 获取名称和 编码数组
            this.getCodeTypeList(queryParams)
        },

        // 加载表格
        loadDetailTable() {
            if (this.$refs.detailTable) {
                // 请求参数
            	this.$refs.detailTable.queryParams.rules = this.queryParams.rules
            	this.$refs.detailTable.queryParams.unitProjectIdList = this.queryParams.unitProjectIdList

            	this.$refs.detailTable.loadData(1)
            }
        },

        // 选择xml文件点击确定跳转页面中单位工程的下拉列表接口
        getDanWeiList() {
            getSelectUnit({ id: this.curProjectId })
                .then((res) => {
                    if (res.code === 0) {
                        this.DanWeiByProjectList = res.data;
                    }
                })
                .catch((err) => {});
        },

        // 切换表格展示（全部清单、异常清单）
        changeTableType() {
            if(!this.$refs.detailTable.rightValue) {
                this.$message.warning('请选择投标报价单位！')
                return
            }
            this.showAllData = !this.showAllData;
            this.$refs.detailTable ? this.$refs.detailTable.changeData(this.showAllData) : ''
        },

        // 点击重置按钮
        doReset() {
            // 清除全部条件 （排序、筛选）
            if (this.$refs.detailTable) {
                this.$refs.detailTable.clearAll()
            }
        },

        // 点击列过滤
		doFilter() {
            if (this.$refs.detailTable) {
                this.$refs.detailTable.openFilter()
            }
		},

        // 获取全部生效的规则
        getRules() {
            getRulesList({})
                .then((res) => {
                    this.rulesList = res.data;

                    // 加载 系统默认规则
                    let _default = res.data.find(x => x.isDefault === 1)
                    if (_default) {
                        this.queryParams.rules = _default.rules
                    }
                })
                .catch((err) => {
                    this.rulesList = [];
                });
        },

        // 获取全部投标单位列表
        getUnitList() {
            getUnitList({ projectId: this.curProjectId })
                .then(res => {
                    this.tendererList = res.data
                })
                .catch(err => {
                    this.tendererList = []
                })
        },

        /* --------------- 导入弹窗模块 ------------------- */ 
        // 投标单位名称 检查是否重名
        onCheckName() {
            let name = this.addForm.name.replace(/\s+/g, "");
            if (name !== "") {
                checkName({ sname: name, projectId: this.curProjectId })
                    .then((res) => {
                        if (res.operationCode !== 1) {
                            this.$message.warning("该投标单位已存在！请重新填写！");
                            this.addForm.name = "";
                        }
                    })
                    .catch((err) => {});
            }
        },

        // 导入投标报价
        addFile() {
            this.dialogObj.title = "导入投标报价";
            this.dialogObj.visible = true;
            this.dialogObj.type = "add";
            this.dialogObj.addType = "addFile";
            this.dialogObj.width = "800px";
        },

        // 打开预览xml
        openXml() {
            this.dialogObj.addType = "preview";
            this.dialogObj.title = "xml 导入数据预览";
            this.dialogObj.type = "add";
            this.dialogObj.width = "1300px";
        },

        // 导入弹窗确认
        doConfirm() {
            this.btnLoading = true;

            // 第一步  选择文件页面
            if (this.dialogObj.addType === "addFile") {
                let _addList = this.$refs.myUpload.addList;
                if (_addList.length === 0) {
                    this.$message.warning("请上传具体的文件!");
                    this.resetBtnloading();
                    return;
                }

                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        // 存储当前的文件
                        this.fileList = _addList;
                        // 进度条
                        this.progressData.eventList = _addList.filter(x => !x.id)
                        this.progressData.eventList.map((i) => {
                            i.progress = 0
                            i.progressLoading = true
                        })

                        // 如果是xml 直接预览
                        if (this.addForm.fileType === "0") {
                            this.doPreviewXml();
                        }
                    } else {
                        this.resetBtnloading();
                    }
                });
                return;
            }

            // 如果是在差异页面
            if (this.dialogObj.addType === "difference") {
                this.btnLoading = false;
                this.openXml();
                return;
            }

            // 最后一步保存
            if (this.dialogObj.addType === "preview") {
                this.$refs.xmlPreview.doSubmit().then((res => {
					// console.log(res)
					if (res) {
                        // 赋值
                        this.addForm.param1 = this.$refs.xmlPreview.leftData

						let list = []
						this.$refs.xmlPreview.leftData.forEach(x => {
							if (x.danWeiId) {
								list.push(x.danWeiId)
							}
						})
						this.addForm.param2 = list.join(',')

						this.doSave()
					} else {
						this.btnLoading = false
					}
				}))
                return;
            }
        },

        // 文件预览 --xml
        doPreviewXml(callbackFn) {
            let formData = new FormData();
            for (let item of this.fileList) {
                formData.append("file", item);
            }
            formData.append("fileType", this.addForm.fileType === "0" ? 0 : 1);
            formData.append('projectId', this.curProjectId)

            // loading
			// this.pageLoading =  this.$loading({
   //      	  	lock: true,
   //      	  	text: '正在解析中...',
   //      	  	spinner: 'el-icon-loading',
   //      	})

            //xml 预览操作
            this.progressData.show = true
            parseXml(formData, this.progressFn, 0)
                .then((res) => {
                    // loading
					// this.pageLoading.close()

                    if (res.code === 0) {
                        // 进度条
                        this.progressData.eventList[0].progressInfo = '解析成功'
                        this.progressData.eventList[0].progress = 100
                        this.progressData.eventList[0].progressLoading = false
                        let data = this.progressData.eventList[0]
                        this.$set(this.progressData.eventList, 0, data)

                        this.addForm.param1 = res.data.param1; // 数据数组
                        this.addForm.param3 = res.data.param3; // 文件名
                        this.addForm.param4 = res.data.param4; // 后台要的
                        // this.addForm.fileType = res.data.param2.fileType
                        this.addForm.fileAmount = res.data.sumMoney; // 文件读取金额

                        setTimeout(() => {
                            this.progressData.show = false
                            this.progressData.eventList = []
                            this.saveFileId = res.data.fileId

                            // 如果 填写金额 与 文件金额不符，打开 说明弹窗, 否则预览
                            if (
                                parseFloat(this.addForm.amount) !==
                                parseFloat(res.data.sumMoney)
                            ) {
                                this.dialogObj.addType = "difference";
                                this.dialogObj.title = "差异金额说明";
                                this.dialogObj.type = "add";
                                this.dialogObj.width = "500px";
                            } else {
                                this.openXml();
                            }
    
                            this.btnLoading = false;

                        }, 500)
                    } else {
                        this.progressData.eventList[0].progressInfo = '解析失败，请重新上传！'
                        this.progressData.eventList[0].progressLoading = false
                        let data = this.progressData.eventList[0]
                        this.$set(this.progressData.eventList, 0, data)

                        this.resetBtnloading();
                    }
                })
                .catch((err) => {
                    // loading
					// this.pageLoading.close()
                    this.progressData.eventList[0].progressInfo = '解析失败，请重新上传！'
                    this.progressData.eventList[0].progressLoading = false
                    let data = this.progressData.eventList[0]
                    this.$set(this.progressData.eventList, 0, data)

                    this.resetBtnloading();
                });
        },

        // 上传进度函数
        progressFn(progressEvent, index) {
            if (this.progressData.eventList.length > 0) {
                this.progressData.eventList[index].progress =
                    ((progressEvent.loaded / progressEvent.total) * 100) | 0

                // 特殊处理
                if (progressEvent.loaded / progressEvent.total >= 0.9) {
                    this.progressData.eventList[index].progress = 90
                }
                if ((progressEvent.loaded / progressEvent.total) === 1) {
                    this.progressData.eventList[index].progressInfo =
                        '正在解析文件, 请稍后....'
                } else {
                    this.progressData.eventList[index].progressInfo = '正在上传'
                }
                let data = this.progressData.eventList[index]
                this.$set(this.progressData.eventList, index, data)
            }
        },

        // 最终保存
        doSave() {
            let params = this.$utils.clone(this.addForm, true);
            params.projectId = this.curProjectId;
            // 筛选掉没有选单位工程的
            let resetparam1 = params.param1.filter((x) => {
                return x.danWeiId !== "" && x.danWeiId !== undefined;
            });
            params = { ...params, param1: resetparam1 };

            // loading
			this.pageLoading =  this.$loading({
        	  	lock: true,
        	  	text: '正在保存中...',
        	  	spinner: 'el-icon-loading',
        	})

            // 接口保存
            saveData(params)
                .then((res) => {
                    // loading
					this.pageLoading.close()

                    this.$message.success("导入成功！");
                    this.handleClose();

                    // 更新单位
                    if (this.$refs.detailTable) {
                        this.$refs.detailTable.getUnitList()
                    }
                })
                .catch((err) => {
                    // loading
					this.pageLoading.close()

                    this.resetBtnloading();
                });
        },

        // 导入弹窗取消
        doCancel() {
            // 第一步  直接关闭
            if (this.dialogObj.addType === "addFile") {
                this.handleClose();
                return;
            }

            // 差异页面 返回上一步
            if (this.dialogObj.addType === "difference") {
                this.addFile();
                return;
            }

            // 最终页面
            if (this.dialogObj.addType === "preview") {
                this.handleClose();
                return;
            }
        },

        // 关闭弹窗事件
        handleClose() {
            this.dialogObj.visible = false;
            this.dialogObj.title = "导入投标报价";
            this.dialogObj.type = "add";
            this.dialogObj.addType = "addFile";
            this.dialogObj.width = "800px";
            this.btnLoading = false;
            // 清空addForm
            this.$refs.myUpload ? this.$refs.myUpload.clearFiles() : "";
            this.addForm.name = "";
            this.addForm.sumMoney = undefined;
            this.addForm.phase = "";
            this.addForm.priceBasis = "1006002";
            this.addForm.fileType = "0";
            this.addForm.param1 = [];
            this.addForm.param2 = "";
            this.addForm.param3 = "";
            this.addForm.param4 = [];

            // 删除附件
            if (this.saveFileId.length > 0) {
                this.deleteFile()
            }
        },

        /* --------------- 规则弹窗模块 ------------------- */ 
        // 打开规则弹窗（手动分析）
        openRule() {
            if(!this.$refs.detailTable.rightValue) {
                this.$message.warning('请选择投标报价单位！')
                return
            }
            this.ruleDialog.mode = 'edit';
            this.ruleDialog.step = 2;
            this.ruleDialog.width = "1200px";
            this.ruleDialog.visible = true;
        },

        // 规则弹窗确认
        onRuleConfirm() {
            if (this.$refs.ruleTable) {
                // 更新保存一次规则
                this.queryParams.rules = this.$refs.ruleTable.rules;
                this.ruleDialog.visible = false;
                // 加载数据
                this.loadDetailTable();
                this.showAllData = true;
            }
        },

        // 规则弹窗关闭
        handleRuleClose() {
            this.ruleDialog.step = 0;
        },

        // 恢复按钮
        resetBtnloading() {
            setTimeout(() => {
                this.btnLoading = false;
                this.progressData.show = false
                this.progressData.eventList = []
            }, 2000);
        },

        // 删除文件
        deleteFile() {
            deleteFile({id: this.saveFileId})
                .then(res => {
                    this.saveFileId = []
                })
        },


        //导出/生成分析报告 - zwh
        doExport(type){
            if(!this.$refs.detailTable.rightValue) {
                this.$message.warning('请选择投标报价单位！');
                return
            }

            if (
                this.$refs.detailTable &&
                this.$refs.detailTable.getListData().length === 0
            ) {
                this.$message.info('暂时没有要导出的数据！')
                return
            }

            let fileName = '清标分析报告' + dateFormat('yyyy-MM-dd hh:ss:mm')
            let params = {}
            params.projectId = this.curProjectId
            params.projectName = this.projectName
            params.exportType = type
            params.fileName = fileName
            params.baseValue = '控制价'
            params.compareValue = this.$refs.detailTable.curTendererName
            params.analysisName = this.userName
            params.snameRuleTxt = this.getRuleText('sname')
            params.featureRuleTxt = this.getRuleText('feature')
            params.unitRuleTxt = this.getRuleText('unit')
            params.quantitiesRuleTxt = this.getRuleText('quantities')
            params.perPriceRuleTxt = this.getRuleText('perPrice')
            params.totalPriceRuleTxt = this.getRuleText('totalPrice')
            params.list = this.$refs.detailTable.getListData() || []

            //else params.list = this.$refs.detailTable.allTableData.filter((x) => x.analysisResult !== "") || [];
            // if(this.showAllData) params.list = this.$refs.detailTable.getOriTableData()
            // else params.list = this.$refs.detailTable.getOriTableData().filter((x) => x.analysisResult !== "") || [];

            /*
            console.log("===snameRuleTxt=> " + params.snameRuleTxt)
            console.log("===featureRuleTxt=> " + params.featureRuleTxt)
            console.log("===unitRuleTxt=> " + params.unitRuleTxt)
            console.log("===quantitiesRuleTxt=> " + params.quantitiesRuleTxt)
            console.log("===perPriceRuleTxt=> " + params.perPriceRuleTxt)
            console.log("===totalPriceRuleTxt=> " + params.totalPriceRuleTxt)
            return
            */
            exportExcel(
                'billRule/expertAnalysisReport',
                params,
                fileName
            )
        },
        getRuleText(type) {
            let txt = ''
            if(type == 'sname' && this.queryParams.rules.sname && this.queryParams.rules.sname == 1) {
                txt = '文字不一致'
            } else if(type == 'feature' && this.queryParams.rules.sname && this.queryParams.rules.feature == 1) {
                txt = '文字不一致'
            } else if(type == 'unit' && this.queryParams.rules.sname && this.queryParams.rules.unit == 1) {
                txt = '文字不一致'
            } else if(type == 'quantities'){
                if(this.queryParams.rules.quantities.type == 0) {
                    txt = '数值不一致'
                } else if(this.queryParams.rules.quantities.type == 1) {
                    let plusValue = String(this.queryParams.rules.quantities.plusValue)
                    let plusRange = String(this.queryParams.rules.quantities.plusRange)
                    let plusAlso = String(this.queryParams.rules.quantities.plusAlso)
                    let minusValue = String(this.queryParams.rules.quantities.minusValue)
                    let minusRange = String(this.queryParams.rules.quantities.minusRange)
                    let minusAlso = String(this.queryParams.rules.quantities.minusAlso)
                    let txtTemp = this.commonRuleTxt(plusValue, plusRange, minusValue, minusRange, plusAlso, minusAlso)
                    txt += txtTemp;
                }
            } else if(type == 'perPrice'){
                if(this.queryParams.rules.perPrice.type == 0) {
                    txt = '数值不一致'
                } else if(this.queryParams.rules.perPrice.type == 1) {
                    let plusValue = String(this.queryParams.rules.perPrice.plusValue)
                    let plusRange = String(this.queryParams.rules.perPrice.plusRange)
                    let plusAlso = String(this.queryParams.rules.perPrice.plusAlso)
                    let minusValue = String(this.queryParams.rules.perPrice.minusValue)
                    let minusRange = String(this.queryParams.rules.perPrice.minusRange)
                    let minusAlso = String(this.queryParams.rules.perPrice.minusAlso)
                    let txtTemp = this.commonRuleTxt(plusValue, plusRange, minusValue, minusRange, plusAlso, minusAlso)
                    txt += txtTemp;
                }
            } else if(type == 'totalPrice'){
                if(this.queryParams.rules.totalPrice.type == 0) {
                    txt = '数值不一致'
                } else if(this.queryParams.rules.quantities.type == 1) {
                    let plusValue = String(this.queryParams.rules.totalPrice.plusValue)
                    let plusRange = String(this.queryParams.rules.totalPrice.plusRange)
                    let plusAlso = String(this.queryParams.rules.totalPrice.plusAlso)
                    let minusValue = String(this.queryParams.rules.totalPrice.minusValue)
                    let minusRange = String(this.queryParams.rules.totalPrice.minusRange)
                    let minusAlso = String(this.queryParams.rules.totalPrice.minusAlso)
                    let txtTemp = this.commonRuleTxt(plusValue, plusRange, minusValue, minusRange, plusAlso, minusAlso)
                    txt += txtTemp;
                }
            }

            return txt
        },
        commonRuleTxt(plusValue, minusValue, plusRange, minusRange, plusAlso , minusAlso){
            let txt = '数量变化过大，'
            let plusAlsoTxt = ''
            if(plusAlso == 0) plusAlsoTxt = '或'
            else if(plusAlso == 1) plusAlsoTxt = '且'
            if(plusValue != null && plusValue != '' && plusRange != null && plusRange != '')
                txt += '变化值+' + plusValue + plusAlsoTxt + '变化幅度+' + plusRange + '%'
            else if(plusValue != null && plusValue != '' && (plusRange == null || plusRange == ''))
                txt += '变化值+' + plusValue
            else if((plusValue == null && plusValue == '') && plusRange != null && plusRange != '')
                txt += '变化幅度+' + plusRange + '%'
            txt += "；"

            let minusAlsoTxt = ''
            if(minusAlso == 0) minusAlsoTxt = '或'
            else if(minusAlso == 1) minusAlsoTxt = '且'
            if(minusValue != null && minusValue != '' && minusRange != null && minusRange != '') {
                txt += '变化值-' + minusValue + minusAlsoTxt + '变化幅度-' + minusRange + '%'
                txt += "；"
            } else if(minusValue != null && minusValue != '' && (minusRange == null || minusRange == '')) {
                txt += '变化值-' + minusValue
                txt += "；"
            } else if((minusValue == null || minusValue == '') && minusRange != null && minusRange != '') {
                txt += '变化幅度-' + minusRange + '%'
                txt += "；"
            }

            return txt
        },

        // 获取编码分类数组
        getCodeTypeList(params) {
            getClearNameUnits(params)
                .then(res => {
                    if (this.$refs.detailTable) {
                        // 清单名称过滤数组
                        this.$refs.detailTable.filterObj.nameList =
                            res.data.billNames
                        // 清单编码数组
                        let _list = this.$utils.toArrayTree(
                            res.data.billCodes,
                            { parentKey: 'pid' }
                        );
                        // 删除多余的 children 空数组
                        this.$utils.eachTree(_list, item => {
                            if (item.children && item.children.length === 0) {
                                delete item.children
                            }
                        });
                        this.$refs.detailTable.filterObj.codeList = _list

                        // 单位数组
                        this.$refs.detailTable.filterObj.unitList =
                            res.data.billUnits
                    }
                })
                .catch(err => {})
        },

        changeUnit(){
            this.showAllData = true;
        }
    },
    computed: {
        // 项目名称
        projectName() {
            return this.$route.query.projectName;
        },

        // 项目ID
        curProjectId() {
            return this.$route.query.projectId;
        },

        // 角色按钮权限
        ...mapState("menu", {
            roleBtns: (state) => state.roleBtns,
        }),

        // 用户名称
        ...mapState("user", {
            userName: (state) => state.userInfo.sname,
        }),

        // 计价依据
        ...mapState("dict", {
            basisList: (state) => state.jjyj,
        }),

        // 文件上传 文件类型
        acceptType() {
            return this.addForm.fileType === "1" ? ["xls", "xlsx"] : ["xml", "XML"];
        },

        // 计算差款金额
        computePrice() {
            return parseFloat(this.addForm.fileAmount).sub(
                parseFloat(this.addForm.sumMoney)
            );
        },

        // 计算差款幅度
        computeRange() {
            return parseFloat(this.addForm.sumMoney) === 0
                ? 0
                : (
                      ((parseFloat(this.addForm.fileAmount) -
                          parseFloat(this.addForm.sumMoney)) /
                          parseFloat(this.addForm.sumMoney)) *
                      100
                  ).toFixed(2);
        },
    },
};
</script>

<style scoped lang="less">
.clear-section-main {
    .help-title {
        color: #409eff;
        font-size: 14px;
        display: inline-block;
        line-height: 32px;
        margin: 0 15px;
        cursor: pointer;
    }
}
</style>
<style lang="less">
.help-content {
    line-height: 20px;
    font-size: 12px;
}
</style>
